import { useEffect, useState } from 'react';

const BARCODE_TTL_SEC = 15 * 60;

function formatRemain(sec: number) {
    const mm = String(Math.floor(sec / 60)).padStart(2, '0');
    const ss = String(sec % 60).padStart(2, '0');
    return `${mm}:${ss}`;
}

function useBarcodeTimer(active: boolean) {
    const [remainSec, setRemainSec] = useState(BARCODE_TTL_SEC);

    const refresh = () => {
        setRemainSec(BARCODE_TTL_SEC);
    };

    useEffect(() => {
        if (!active) return undefined;
        setRemainSec(BARCODE_TTL_SEC);
        const id = window.setInterval(() => {
            setRemainSec((prev) => {
                if (prev <= 1) {
                    return BARCODE_TTL_SEC;
                }
                return prev - 1;
            });
        }, 1000);
        return () => window.clearInterval(id);
    }, [active]);

    return { remainLabel: formatRemain(remainSec), refresh };
}

export default useBarcodeTimer;
